export default "__VITE_ASSET__Di8F9IGu__"